import { render, staticRenderFns } from "./RenderColor.vue?vue&type=template&id=026b0a94&scoped=true"
import script from "./RenderColor.vue?vue&type=script&lang=ts"
export * from "./RenderColor.vue?vue&type=script&lang=ts"
import style0 from "./RenderColor.vue?vue&type=style&index=0&id=026b0a94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026b0a94",
  null
  
)

export default component.exports